import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { useDocstate } from "@/context/DocstateContext";
import { PROPERTY_TYPES, cap, dl } from "@/lib/docstate";

const BEDS = ["", "1", "2", "3", "4", "5+"];

export const HeroSearch = () => {
  const data = useDocstate();
  const communities = data?.communities || [];
  const navigate = useNavigate();
  const [purpose, setPurpose] = useState("sale");
  const [community, setCommunity] = useState("");
  const [type, setType] = useState("");
  const [beds, setBeds] = useState("");

  const submit = (e) => {
    e?.preventDefault();
    const p = new URLSearchParams();
    p.set("purpose", purpose);
    if (community) p.set("community", community);
    if (type) p.set("type", type);
    if (beds) p.set("beds", beds);
    navigate(dl(`/properties?${p.toString()}`));
  };

  return (
    <form
      onSubmit={submit}
      data-testid="hero-search"
      className="w-full rounded-2xl border border-[#C9A24B]/30 bg-[#121214]/90 p-4 shadow-[0_25px_60px_rgba(0,0,0,0.8)] backdrop-blur-2xl sm:p-5"
    >
      <div className="mb-4 inline-flex rounded-full border border-[#C9A24B]/25 bg-[#0B0B0C]/60 p-1">
        {["sale", "rent"].map((p) => (
          <button
            key={p}
            type="button"
            onClick={() => setPurpose(p)}
            data-testid={`hero-search-${p === "sale" ? "buy" : "rent"}-tab`}
            className={`rounded-full px-6 py-2 text-xs font-semibold uppercase tracking-[0.14em] transition-colors ${purpose === p ? "bg-gradient-to-r from-[#C9A24B] to-[#B8912E] text-[#0B0B0C]" : "text-[#C9BBB2] hover:text-[#F3E5AB]"}`}
          >
            {p === "sale" ? "Buy" : "Rent"}
          </button>
        ))}
      </div>
      <div className="grid gap-3 md:grid-cols-[1.4fr_1fr_0.8fr_auto]">
        <select value={community} onChange={(e) => setCommunity(e.target.value)} data-testid="hero-search-community" className="ds-input">
          <option value="">All Communities</option>
          {communities.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <select value={type} onChange={(e) => setType(e.target.value)} data-testid="hero-search-type" className="ds-input">
          <option value="">Any Type</option>
          {PROPERTY_TYPES.map((t) => <option key={t} value={t}>{cap(t)}</option>)}
        </select>
        <select value={beds} onChange={(e) => setBeds(e.target.value)} data-testid="hero-search-beds" className="ds-input">
          {BEDS.map((b) => <option key={b} value={b}>{b ? `${b} Beds` : "Any Beds"}</option>)}
        </select>
        <button type="submit" data-testid="hero-search-submit-button" className="ds-gold-btn px-7 py-3 text-sm">
          <Search className="h-4 w-4" /> Search
        </button>
      </div>
    </form>
  );
};
